import { Children } from 'react';
import { Grid, GridItem } from '@optimus-web/core';
import { GridProps } from '@optimus-web/core/src/Grid/types';

export const ResponsiveTwoColumns: React.FC<
    React.PropsWithChildren<Omit<GridProps, 'templateColumns' | 'tabletMax'>>
> = ({ children, ...props }) => (
    <Grid {...props} templateColumns="1fr 1fr" tabletMax={{ templateColumns: '1fr' }}>
        {Children.map(children, (child) => (
            <GridItem overflow="auto">{child}</GridItem>
        ))}
    </Grid>
);
